import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="page-container">
            <div className="content-wrap">
                {/* Main content goes here */}
            </div>
            <footer className="footer-section" style={{ marginBottom: "0" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footerOne">
                                <div className="footOne">
                                    <a href="https://play.google.com/store/apps/details?id=com.roof.estimator&pli=1" className="footerLogo" target="_blank" rel="noopener noreferrer">
                                        <img
                                            src="assets/images/logo/logo-icon.svg"
                                            alt="logo"
                                            className="comapany-logo img-contain"
                                        />
                                    </a>
                                    <h5 className="footDownload">Download The App</h5>
                                </div>
                                <div className="footTwo">
                                    <ul className="footTwoUl">
                                        <li className="footTwoLi">
                                            <a href="https://play.google.com/store/apps/details?id=com.roof.estimator&pli=1" target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src="assets/images/icons/google-play.svg"
                                                    alt="google-play"
                                                    className="footerStoreImg img-contain"
                                                />
                                            </a>
                                        </li>
                                        <li className="footTwoLi">
                                            <a href="https://apps.apple.com/app/id1234567890" target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src="assets/images/icons/apple-play.svg"
                                                    alt="apple-play"
                                                    className="footerStoreImg img-contain"
                                                />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="footerBorder" />
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footerTwo">
                                <ul className="footer-ul">
                                    <li className="footer-li">
                                        <p className="copyrightText">Copyright ©Roof Estimator {currentYear}</p>
                                    </li>
                                </ul>
                                <ul className="footer-ul">
                                    <li className="footer-li">
                                        <Link className="footer-link" to="/Home">
                                            Home
                                        </Link>
                                    </li>
                                    <li className="footer-li">
                                        <Link className="footer-link" to="/about-us">
                                            About Us
                                        </Link>
                                    </li>
                                    <li className="footer-li">
                                        <Link className="footer-link" to="/contact-us">
                                            Contact Us
                                        </Link>
                                    </li>
                                    <li className="footer-li">
                                        <Link className="footer-link" to="/faq">
                                            FAQ
                                        </Link>
                                    </li>
                                    <li className="footer-li">
                                        <Link className="footer-link" to="/terms_condition">
                                            T&amp;C
                                        </Link>
                                    </li>
                                    <li className="footer-li">
                                        <Link className="footer-link" to="/privacy_policy">
                                            Privacy Policy
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
